import { gql } from 'apollo-angular';

export const contactFragment = gql`
fragment ContactFields on Contact
{
    contactName
    contactRole
    telephone
    email
    skype
    primary
}`;
